import React, { FC, useState } from "react";

import { Stack } from "@mui/material";
import Button from "@mui/material/Button";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";

import DeleteActionDialog, {
  Entry,
} from "../../../components/DeleteActionDialog";
import Header from "../../../components/Header";
import UserAvatar from "../../../components/UserAvatar";
import UserDisplayName from "../../../components/UserDisplayName";
import { useSelector } from "../../../store";
import {
  useListUsersInOrganizationQuery,
  useRemoveUserFromOrganizationMutation,
} from "../../../store/pomeriumApi";
import Invite from "./Invite";

const List: FC = () => {
  const { organizationId } = useSelector((state) => state.current);
  const [showDelete, setShowDelete] = useState(false);
  const [selected, setSelected] = useState<Entry[]>([]);

  const [deleteUser] = useRemoveUserFromOrganizationMutation();
  const { data: users } = useListUsersInOrganizationQuery(
    { organizationId },
    {
      skip: !organizationId,
    },
  );

  function handleCloseDelete() {
    setShowDelete(false);
  }

  async function handleDelete() {
    await Promise.all(
      selected.map((user) => deleteUser({ organizationId, userId: user.id })),
    );
  }

  const clickRemove = (id: string, name: string) => {
    setSelected([{ id, name }]);
    setShowDelete(true);
  };

  return (
    <>
      <DeleteActionDialog
        buttonText="Remove"
        name="Team Members"
        open={showDelete}
        entries={selected}
        onClose={handleCloseDelete}
        onDelete={handleDelete}
      />
      <Header title="Team" breadcrumbs={false} actions={<Invite />} />
      <Table>
        <TableBody>
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell>Actions</TableCell>
          </TableRow>
        </TableBody>
        <TableBody>
          {users
            ?.filter((u) => u.type === "user_type_interactive")
            ?.map((user) => (
              <TableRow
                key={"team_" + user.id}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell>
                  <Stack
                    direction="row"
                    gap={2}
                    alignContent="center"
                    alignItems="center"
                  >
                    <UserAvatar variant="rounded" user={user} />
                    <UserDisplayName user={user} />
                  </Stack>
                </TableCell>
                <TableCell>
                  <Stack direction="row">
                    {user.organizationRole !== "owner" && (
                      <Button
                        key={"remove_" + user.id}
                        color="error"
                        onClick={() =>
                          clickRemove(user.id, user.displayName || "")
                        }
                      >
                        Remove
                      </Button>
                    )}
                  </Stack>
                </TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </>
  );
};
export default List;
